import { render } from "./EditAdmin.vue?vue&type=template&id=6015aaae&scoped=true"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"

import "./EditAdmin.vue?vue&type=style&index=0&id=6015aaae&scoped=true&lang=less"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6015aaae"]])

export default __exports__